import React from 'react';
import { Ornament } from './Ornament';
import { growth } from '../data/content';
export function GrowthMessage() {
  return <section className="bg-cream text-ink" data-id="element-96" data-mp="1b5btku75erw2">
      <div className="mx-auto max-w-3xl px-5 py-20 text-center sm:px-6 lg:py-28" data-id="element-97" data-mp="1b27idcv9mvvw">
        <h2 className="text-brown" data-id="element-98" data-mp="1oxjnme71s4r2">
          <span className="block font-display text-[1.75rem] font-semibold uppercase leading-tight tracking-[0.06em] sm:text-4xl" data-id="element-99" data-mp="1k4ytfbk8bpn0">
            {growth.line1}
          </span>
          <span className="mt-2 block font-script text-[3rem] leading-[1.05] text-rose sm:text-7xl" data-id="element-100" data-mp="1yvfz573wd1pp">
            {growth.line2}
          </span>
        </h2>

        <div className="mx-auto mt-8 max-w-xl space-y-3 font-sans text-[0.98rem] leading-relaxed text-ink-soft sm:text-[1.05rem]" data-id="element-101" data-mp="27t01kjdhx41w">
          {growth.body.map(paragraph => <p key={paragraph} data-id="element-102" data-mp="dg0c7yjbcvhf">{paragraph}</p>)}
        </div>

        <Ornament className="mt-10" data-id="element-103" data-mp="dgju5f8yrjvg" />

        <ul className="mt-8 space-y-2" data-id="element-104" data-mp="9eyfppgs6xj5">
          {growth.rhythm.map(line => <li key={line} className="font-display text-[1.45rem] font-medium italic text-brown sm:text-2xl" data-id="element-105" data-mp="9grnx971lpt9">
              {line}
            </li>)}
        </ul>
      </div>
    </section>;
}